// <dt-delivery-date data-min="5" data-max="8"> → "Mon, Oct 6 – Thu, Oct 9"
// <dt-delivery-date data-days="2"> → "Thu, Oct 1" (single date, e.g. dispatch)
// Business days (Mon–Fri) counted from today. Defined here, outside the cart
// drawer markup, so drawer re-renders (innerHTML) still upgrade the element.
(function () {
  if (customElements.get('dt-delivery-date')) return;
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) days--;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  customElements.define('dt-delivery-date', class extends HTMLElement {
    connectedCallback() {
      var now = new Date();
      if (this.dataset.days) {
        this.textContent = fmt(addBusinessDays(now, parseInt(this.dataset.days, 10) || 0));
        return;
      }
      var min = parseInt(this.dataset.min, 10) || 5;
      var max = parseInt(this.dataset.max, 10) || 12;
      this.textContent = fmt(addBusinessDays(now, min)) + ' – ' + fmt(addBusinessDays(now, max));
    }
  });
})();
